import type { PropsWithChildren } from "react";

import { css } from "@compiled/react";

export type Adg4RaisedMediaProps = PropsWithChildren<{
    className?: string;
}>;

const raisedImage = css({
    boxShadow:
        "0px 8px 12px 0px rgba(9, 30, 66, 0.15), 0px 0px 1px 0px rgba(9, 30, 66, 0.31)",
    borderRadius: 12,
    display: "flex",
    overflow: "hidden"
});

export const Adg4RaisedMedia = ({
    className,
    children
}: Adg4RaisedMediaProps) => {
    return (
        <div className={className} css={raisedImage}>
            {children}
        </div>
    );
};
